/** The map choice of the setup screens (GDD section 10): « Random », then the maps of the GDD in its order. */
import { MAPS, MAP_IDS, isMapId, mapDef, type MapId } from '@invaders/game';
import { drawMapPreview } from './map-preview';

export const RANDOM_MAP = 'random';

/**
 * Fills a map select, with its line of description and its preview (the map built from `seed()`). Returns a function
 * that draws the preview again (when the seed changes).
 */
export function fillMapSelect(select: HTMLSelectElement, blurb?: HTMLElement, preview?: HTMLCanvasElement, seed: () => number = () => 1): () => void {
  select.innerHTML = `<option value="${RANDOM_MAP}">Random</option>` + MAPS.map((m) => `<option value="${m.id}">${m.name}</option>`).join('');
  const show = () => {
    if (blurb) blurb.textContent = isMapId(select.value) ? mapDef(select.value).blurb : 'One of the maps, drawn at the start';
    if (preview) drawMapPreview(preview, select.value, seed());
  };
  select.addEventListener('change', show);
  show();
  return show;
}

/** The map of the scenario: the one chosen, or one drawn at random (by the host, before the scenario is sent). */
export function resolveMap(choice: string): MapId {
  return isMapId(choice) ? choice : MAP_IDS[Math.floor(Math.random() * MAP_IDS.length)];
}

export function mapLabel(choice: string): string {
  return isMapId(choice) ? mapDef(choice).name : 'random map';
}
